import { useEffect } from "react";
import { SERVER_URL } from "../../../config/config";
import { SSE_HEADER } from "../../../constants/sse";
import { useAppDispatch } from "../../../app/hooks";
import useWallet from "../../../hook/useWallet";
import { getJailedUntilAction } from "../../../reducers/game.slice";

const useJailSSE = () => {
  const dispatch = useAppDispatch();
  const { account } = useWallet();

  useEffect(() => {
    const jailEventSource = new EventSource(`${SERVER_URL}/event/jail`);
    jailEventSource.onmessage = (e) => {
      if (e.data.includes("welcome")) {
        console.log("welcome event");
      } else if (e.data.includes("eventName")) {
        const event = JSON.parse(e.data);

        if (
          event.eventName === SSE_HEADER.JAIL.BUST_OUT_PRISONER ||
          event.eventName === SSE_HEADER.JAIL.BUY_OUT_PRISONER
        ) {
          if (event.data.prisoner.toLowerCase() === account.toLowerCase())
            dispatch(getJailedUntilAction(account));
        }
      }
    };

    return () => {
      jailEventSource.close();
    };
  }, [dispatch, account]);
};

export default useJailSSE;
